import React, {Component} from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';

// import Select from 'react-select';

import {
  FilterButton,
  DropdownAnchor
} from '../HelperComponents/StyledComponents';

import { setVisibilityFilter } from '../../actions/DataDefaultActions';

import { bindActionCreators } from 'redux';

class FilterDropdown extends Component {
  state = {
    active: false
  }
  
  toggleDropdown = () => {
    this.setState({
      active: !this.state.active
    })
  }

  onKeyPressed = (e) => {
    if (e.keyCode === 27) {
      this.setState({
        active: false
      })
    }
  }


  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      // alert('You clicked outside of me!');
      this.setState({
        active: false
      })
    }
  }

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  }

  render() {
    return (
      <section className="is-inline-block" onKeyDown={this.onKeyPressed} ref={this.setWrapperRef}>
        <div className={`dropdown ${this.state.active ? 'is-active' : ''}`} onClick={this.toggleDropdown}>
          <div className="dropdown-trigger">
            <FilterButton className="button" aria-haspopup="true" aria-controls="dropdown-menu">
              <span>{this.props.name}</span>
            </FilterButton>
          </div>
          <div className="dropdown-menu" id="dropdown-menu" role="menu">
            <section className="dropdown-content" style={{ backgroundColor: '#333', maxHeight: '50vh', overflowY: 'auto' }}>
              {
                _.map(this.props.items, (item, i) => (
                  <DropdownAnchor className="dropdown-item has-text-white" key={`dropdown_item_${item.id}`} onClick={() => this.props.setVisibilityFilter({ type: this.props.type, filter: { id: item.id, name: item.title.rendered } }) }>
                    {item.title.rendered}
                  </DropdownAnchor>
                ))
              }
            </section>
          </div>
        </div>
      </section>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setVisibilityFilter }, dispatch);
}

export default connect(null, mapDispatchToProps)(FilterDropdown);


// WEBPACK FOOTER //
// ./src/components/Filters/FilterDropdown.js